import { isNative } from './platform';

/**
 * Écran de lancement.
 *
 * La configuration précédente masquait le splash automatiquement après deux
 * secondes. Sur un appareil lent ou un réseau poussif, l'application Vue
 * n'était pas encore montée à cet instant : l'utilisateur voyait un écran
 * blanc avant l'apparition de l'accueil.
 *
 * `launchAutoHide` est donc passé à false dans capacitor.config.json, et c'est
 * l'application qui décide du moment : le splash reste affiché jusqu'à ce que
 * la première vue soit réellement montée.
 *
 * Contrepartie : si le JavaScript échoue avant le montage, plus personne
 * n'appelle hide() et le splash reste indéfiniment. Le garde-fou ci-dessous
 * l'écarte quoi qu'il arrive, quitte à révéler un écran cassé — un écran cassé
 * se diagnostique, un splash figé ressemble à un plantage.
 */

const FALLBACK_DELAY = 6000;

let hidden = false;

export async function hideSplash() {
  if (!isNative() || hidden) return;
  hidden = true;
  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide();
  } catch (e) {
    console.warn('Masquage du splash impossible', e);
  }
}

export function armSplashFallback() {
  if (!isNative()) return;
  window.setTimeout(hideSplash, FALLBACK_DELAY);
}
